import React from 'react';
import { Dropdown, FluentProvider, Option, webLightTheme } from '@fluentui/react-components';
import Collapsible from './Collapsible';
import { IGenericFilterTag } from '../../../utils/types/IGenericFilterTag';

export interface IBooleanCollapsibleDropdownProps {
  onSelectedItems?: (selectedItems: IGenericFilterTag) => void;
  initialValues?: IGenericFilterTag;
  label: string;
  dataKey: string;
}

const BooleanCollapsibleDropdown = (props: IBooleanCollapsibleDropdownProps): JSX.Element => {
  const { onSelectedItems, initialValues, label, dataKey } = props;

  const selectedValue = initialValues?.values?.[0]?.name ?? '';

  const onChange = (_: unknown, data: { optionValue?: string; optionText?: string }): void => {
    const values =
      data.optionValue && data.optionValue !== ''
        ? [{ key: data.optionValue, name: data.optionText }]
        : [];

    onSelectedItems({
      dataKey,
      title: label,
      values,
    });
  };

  return (
    <Collapsible text={label}>
      <FluentProvider theme={webLightTheme}>
        <Dropdown
          placeholder="Select an option"
          style={{ width: '100%' }}
          value={selectedValue}
          onOptionSelect={onChange}
        >
          <Option value="">--</Option>
          <Option value="true">Yes</Option>
          <Option value="false">No</Option>
        </Dropdown>
      </FluentProvider>
    </Collapsible>
  );
};

export default BooleanCollapsibleDropdown;
